/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { TrainingSummaryRequest } from '../models/TrainingSummaryRequest';
import { HttpFile } from '../http/http';

export class TrainingSessionCreateRequest {
    'taggedHorses'?: Array<string>;
    'intensity'?: number;
    'satisfaction'?: number;
    'bootsWeight'?: number;
    'startIndex'?: number;
    'endIndex'?: number;
    'locationString'?: string;
    'dataIncorrect'?: boolean;
    'trainingSummary'?: TrainingSummaryRequest;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "taggedHorses",
            "baseName": "taggedHorses",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "intensity",
            "baseName": "intensity",
            "type": "number",
            "format": ""
        },
        {
            "name": "satisfaction",
            "baseName": "satisfaction",
            "type": "number",
            "format": ""
        },
        {
            "name": "bootsWeight",
            "baseName": "bootsWeight",
            "type": "number",
            "format": ""
        },
        {
            "name": "startIndex",
            "baseName": "startIndex",
            "type": "number",
            "format": ""
        },
        {
            "name": "endIndex",
            "baseName": "endIndex",
            "type": "number",
            "format": ""
        },
        {
            "name": "locationString",
            "baseName": "locationString",
            "type": "string",
            "format": ""
        },
        {
            "name": "dataIncorrect",
            "baseName": "dataIncorrect",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "trainingSummary",
            "baseName": "trainingSummary",
            "type": "TrainingSummaryRequest",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return TrainingSessionCreateRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

